import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bg-white" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "mb-5" }, "Please find the following legal documents below:", -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", { class: "text-lg mb-5 font-bold" }, "Terms Of Service", -1)
const _hoisted_5 = ["href"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h3", { class: "text-lg mb-5 font-bold" }, "Policies", -1)
const _hoisted_8 = ["href"]
const _hoisted_9 = { key: 2 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h3", { class: "text-lg mb-5 font-bold" }, "Forms & Guides", -1)
const _hoisted_11 = ["href"]
const _hoisted_12 = { key: 3 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h3", { class: "text-lg mt-10 mb-5 font-bold" }, "Legacy Documents", -1)
const _hoisted_14 = ["href"]

import HeroText from '../components/content/HeroText.vue';
import Text from '../components/content/Text.vue';
import Container from '../components/content/Container.vue';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import { BrandServiceInterface } from '@/services/brand/brandServiceInterface';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');

const legalDocuments = brandService.getLegalDocuments();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Container, null, {
      default: _withCtx(() => [
        _createVNode(HeroText, {
          title: "Legal Information.",
          subtitle: ""
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Container, null, {
        default: _withCtx(() => [
          _createVNode(Text, null, {
            default: _withCtx(() => [
              _hoisted_2,
              (_unref(legalDocuments).termsOfService.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _hoisted_4,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(legalDocuments).termsOfService, (legalDocument) => {
                      return (_openBlock(), _createElementBlock("p", {
                        class: "mb-5",
                        key: legalDocument.name
                      }, [
                        _createElementVNode("a", {
                          href: legalDocument.url,
                          class: "text-blue-500 hover:text-blue-800 hover:underline transition duration-250",
                          target: "_blank"
                        }, _toDisplayString(legalDocument.name), 9, _hoisted_5)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_unref(legalDocuments).policies.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _hoisted_7,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(legalDocuments).policies, (legalDocument) => {
                      return (_openBlock(), _createElementBlock("p", {
                        class: "mb-5",
                        key: legalDocument.name
                      }, [
                        _createElementVNode("a", {
                          href: legalDocument.url,
                          class: "text-blue-500 hover:text-blue-800 hover:underline transition duration-250",
                          target: "_blank"
                        }, _toDisplayString(legalDocument.name), 9, _hoisted_8)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_unref(legalDocuments).formsAndGuides.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _hoisted_10,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(legalDocuments).formsAndGuides, (legalDocument) => {
                      return (_openBlock(), _createElementBlock("p", {
                        class: "mb-5",
                        key: legalDocument.name
                      }, [
                        _createElementVNode("a", {
                          href: legalDocument.url,
                          class: "text-blue-500 hover:text-blue-800 hover:underline transition duration-250",
                          target: "_blank"
                        }, _toDisplayString(legalDocument.name), 9, _hoisted_11)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_unref(legalDocuments).legacy.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _hoisted_13,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(legalDocuments).legacy, (legalDocument) => {
                      return (_openBlock(), _createElementBlock("p", {
                        class: "mb-5",
                        key: legalDocument.name
                      }, [
                        _createElementVNode("a", {
                          href: legalDocument.url,
                          class: "text-blue-500 hover:text-blue-800 hover:underline transition duration-250",
                          target: "_blank"
                        }, _toDisplayString(legalDocument.name), 9, _hoisted_14)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})